export { StaticMediaImage } from './StaticMediaImage';
export type { StaticMediaImageProps } from './StaticMediaImage';
